import styled from '@emotion/styled';
import { Link } from 'gatsby';
import { ReactComponent as Arrow } from '../../images/svgs/arrow-breadcrumb.svg';

interface Props {
    blog?: boolean;
}

export const BreadCrumbsStyled = styled.section<Props>`
    div {
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 18px;
    }
    .home {
        transition: color 0.2s ease-in;
        color: #929ea4;
        &:hover {
            color: ${({ theme }) => theme.colors.blue3};
        }
    }
    a {
        flex-shrink: 0;
        color: none;
        cursor: pointer;
        text-transform: capitalize;
        &:last-of-type {
            font-weight: 700;

            color: ${({ theme }) => theme.colors.blue3};
            &:hover {
                color: ${({ theme }) => theme.colors.blue4};
            }
        }
    }
    li,
    a {
        font-size: 16px;
        line-height: 24px;
        color: ${({ theme }) => theme.colors.gray3};
        list-style: none;
        transition: color 0.2s ease-in;

        &:hover {
            color: ${({ theme }) => theme.colors.blue3};
        }
    }
    svg {
        margin: 0px 8px;
        fill: ${({ theme }) => theme.colors.gray3};
    }
    @media ${({ theme }) => theme.device.laptop} {
        a:last-of-type {
            transition: color 0.2s ease-in;
        }
        div {
            display: flex;
            margin-top: ${({ blog }) => (blog ? '140px' : '00px')};
            justify-content: ${({ blog }) => (blog ? 'center' : '')};
            margin-bottom: 16px;
        }
    }
`;

export const BreadCrumbs: React.FC<{ blog?: boolean; links: { path: string; name: string }[] }> = ({
    links,
    blog,
}) => {
    return (
        <BreadCrumbsStyled blog={blog}>
            <div>
                <Link className="home" to="/">
                    {' '}
                    Home
                </Link>
                {links.map(link => (
                    <Link key={link.name} to={link.path}>
                        <Arrow />
                        {link.name}
                    </Link>
                ))}
            </div>
        </BreadCrumbsStyled>
    );
};
